import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ToastQueue } from '@adobe/react-spectrum';
import { useCommentSlice } from './CommentState';
import { selectApiResponseStatus } from './CommentState/selectors';

const ApiStatusManager: React.FC = () => {
  const dispatch = useDispatch();
  const { actions } = useCommentSlice();
  const apiResponseStatus = useSelector(selectApiResponseStatus);

  React.useEffect(() => {
    if (apiResponseStatus.status === 'SUCCESS') {
      ToastQueue.positive(apiResponseStatus.message || '', { timeout: 5000 });
    } else if (apiResponseStatus.status === 'ERROR') {
      ToastQueue.negative(apiResponseStatus.message || '', { timeout: 5000 });
    }
  }, [apiResponseStatus.status, apiResponseStatus.message]);

  // Separate effect to reset API response status after showing toast
  React.useEffect(() => {
    if (
      apiResponseStatus.status === 'SUCCESS' ||
      apiResponseStatus.status === 'ERROR'
    ) {
      const timer = setTimeout(() => {
        dispatch(actions.setApiResponseStatus({ status: null, message: null }));
      }, 100); // Small delay to ensure toast is shown

      return () => clearTimeout(timer);
    }
  }, [apiResponseStatus.status, dispatch]);

  // Cleanup effect to prevent state updates on unmounted component
  React.useEffect(() => {
    return () => {
      dispatch(actions.setApiResponseStatus({ status: null, message: null }));
      dispatch(actions.setLoading(false));
    };
  }, [dispatch]);

  return null; // This component only handles side effects
};

export default ApiStatusManager;
